import { useApplicantHelpers } from "@Client/@Composables/application-standalone/pages/applicants/useApplicantHelpers";
import { useLiabilityHelpers } from "@Client/@Composables/application-standalone/pages/liabilities/useLiabilityHelpers";
import SectionTitle from "@Client/@Modules/application-standalone/components/helpers/section-title.vue";
import PageSummarySectionGroupLayout from "@Client/@Modules/application-standalone/components/layout/page-summary-section-group-layout.vue";
import { defineComponent, computed, ref, onMounted, watch } from "@vue/composition-api";
import { useSummaryHelpers } from "@Client/@Composables/application-standalone/pages/summary/useSummaryHelpers";
import { useValidatorsHelper } from "@Client/@Composables/application-standalone/validations/useValidatorsHelper";
import ApplicationSectionErrorIcon from "@Client/@Modules/application-standalone/components/helpers/application-section-error-icon.vue";
import { ordinalIndex } from "@Shared/@Utils/helpers/text";
import RemoveComponentModal from "./../remove-component-modal.vue";
import { useI18n } from "vue-i18n-composable";
export default defineComponent({
  name: "LiabilitySummary",
  components: {
    PageSummarySectionGroupLayout,
    SectionTitle,
    ApplicationSectionErrorIcon,
    RemoveComponentModal
  },
  props: {
    showErrors: {
      type: Number,
      default: 0
    }
  },
  setup(props, {
    emit
  }) {
    const invalidLiabilities = ref([]);
    const {
      allApplicants,
      applicantNameFromIndex,
      isApplicantVisibleFromFillOut
    } = useApplicantHelpers();
    const {
      addEmptyLiability,
      deleteLiability,
      applicantHasLiabilities,
      isLiabilitySectionVisibleForMainApplicant,
      isLiabilitySectionVisibleForCoApplicants
    } = useLiabilityHelpers();
    const {
      getTextForAddButton,
      editButtonText,
      allowEdit
    } = useSummaryHelpers();
    const {
      getInvalidLiabilities
    } = useValidatorsHelper();
    const {
      t
    } = useI18n();
    const addLiabilityButtonText = computed(() => {
      return getTextForAddButton("application-standalone.pages.liabilities.addLiability", {
        iteratee: applicantHasLiabilities,
        pathToVerify: "liabilities"
      });
    });
    const modalText = computed(() => {
      return t("application-form.removeComponentModalMessage", {
        componentType: "liability"
      });
    });
    const removeComponentModal = ref();
    const openDeletionModal = data => {
      var _removeComponentModal;
      removeComponentModal == null ? void 0 : (_removeComponentModal = removeComponentModal.value) == null ? void 0 : _removeComponentModal.openModal(data);
    };
    onMounted(() => {
      updateInvalidLiabilities();
    });
    const updateInvalidLiabilities = async () => {
      invalidLiabilities.value = await getInvalidLiabilities();
    };
    const areInvalidLiabilities = computed(() => !!invalidLiabilities.value.length);
    watch(areInvalidLiabilities, newValue => emit("disable-save", newValue), {
      immediate: true
    });
    const handleAddLiability = appIndex => {
      const applicantIndex = appIndex != null ? appIndex : 0;
      addEmptyLiability(applicantIndex);
      const applicant = allApplicants.value[applicantIndex];
      if (!applicant) return;
      handleNavigation(applicantIndex, applicant.liabilities.length - 1);
    };
    const handleNavigation = (applicantIndex, liabilityIndex, applicantId = "") => {
      emit("navigate", {
        applicantIndex,
        liabilityIndex,
        applicantId
      });
    };
    const isSectionVisibleToApplicant = (applicantIndex, applicantId) => {
      const visibleFromSchema = applicantIndex === 0 ? isLiabilitySectionVisibleForMainApplicant.value : isLiabilitySectionVisibleForCoApplicants.value;
      const visibleFromFillOut = isApplicantVisibleFromFillOut(applicantId);
      return visibleFromSchema && visibleFromFillOut;
    };
    const isInvalid = (applicantIdx, index) => {
      return invalidLiabilities.value.some(({
        liabilityIndex,
        applicantIndex
      }) => liabilityIndex === index && applicantIndex === applicantIdx);
    };
    const firstErrorId = computed(() => {
      var _invalidLiabilities$v, _invalidLiabilities$v2, _invalidLiabilities$v3;
      return (_invalidLiabilities$v = (_invalidLiabilities$v2 = invalidLiabilities.value) == null ? void 0 : (_invalidLiabilities$v3 = _invalidLiabilities$v2[0]) == null ? void 0 : _invalidLiabilities$v3.liabilityIndex) != null ? _invalidLiabilities$v : null;
    });
    const handleDelete = ({
      applicantIndex,
      liabilityIndex
    }) => {
      deleteLiability(applicantIndex, liabilityIndex);
      emit("save");
      updateInvalidLiabilities();
    };
    return {
      handleDelete,
      handleAddLiability,
      allApplicants,
      applicantNameFromIndex,
      handleNavigation,
      deleteLiability,
      addLiabilityButtonText,
      isSectionVisibleToApplicant,
      isInvalid,
      firstErrorId,
      editButtonText,
      allowEdit,
      applicantHasLiabilities,
      ordinalIndex,
      invalidLiabilities,
      updateInvalidLiabilities,
      modalText,
      openDeletionModal,
      removeComponentModal
    };
  }
});